document.addEventListener("DOMContentLoaded", function() {
  Fancybox.bind('[data-fancybox="gallery-video"]', {
    Html: {
      video: {
        autoplay: true,
        controls: true,
        playsinline: true
      }
    },
    on: {
      ready: (fancybox) => {
        console.log("Fancybox hazır!");
      }
    }
  });
  Fancybox.bind('[data-fancybox="product-gallery"]', {
    Html: {
      video: {
        autoplay: true,
        controls: true,
        playsinline: true
      }
    },
    on: {
      ready: (fancybox) => {
        console.log("Fancybox hazır!");
      }
    }
  });
});


// MOBILE MENU FUNCTIONALITY
(function() {
    const hamburgerToggle = document.getElementById('hamburger-toggle');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const closeMobileMenu = document.getElementById('close-mobile-menu');

    // Open mobile menu
    hamburgerToggle.addEventListener('click', function() {
        hamburgerToggle.classList.add('active');
        mobileMenuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    });

    // Close mobile menu
    function closeMobileMenuFunc() {
        hamburgerToggle.classList.remove('active');
        mobileMenuOverlay.classList.remove('active');
        document.body.style.overflow = 'auto';
    }

    closeMobileMenu.addEventListener('click', closeMobileMenuFunc);

    // Close mobile menu when overlay is clicked
    mobileMenuOverlay.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
            closeMobileMenuFunc();
        }
    });

    // Close mobile menu when menu item is clicked
    const mobileMenuItems = document.querySelectorAll('.mobile-menu-list a');
    mobileMenuItems.forEach(item => {
        item.addEventListener('click', closeMobileMenuFunc);
    });

    // Close mobile menu with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenuOverlay.classList.contains('active')) {
            closeMobileMenuFunc();
        }
    });
})();

function openSearch() {
    const mobileSearch = document.querySelector('.mobile-search');
    const mobileSearchForm = document.querySelector('.mobile-search-form');

    if (mobileSearch && mobileSearchForm) {
        mobileSearch.classList.add('search-opened');
        // onclick özelliğini güncellemek yerine daha modern bir yaklaşım:
        mobileSearch.setAttribute('onclick', 'closeSearch()');
        mobileSearchForm.classList.add('search-opened');
    }
}

function closeSearch() {
    const mobileSearch = document.querySelector('.mobile-search');
    const mobileSearchForm = document.querySelector('.mobile-search-form');

    if (mobileSearch && mobileSearchForm) {
        mobileSearch.classList.remove('search-opened');
        mobileSearch.setAttribute('onclick', 'openSearch()');
        mobileSearchForm.classList.remove('search-opened');
    }
}
// FAQs
(function( $ ){
    $(".collapsed-item").click(function() {
        const $faqArea = $(this).closest('.faq-list-area');
        if (!$(this).hasClass("opened")) {
            $faqArea.find(".collapsed-item.opened").removeClass("opened")
        }
        $(this).toggleClass("opened")
    });

})( jQuery );

const productSliders = new Swiper('.product-card-slider', {
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: false, 
    observer: true,
    observeParents: true,
});

const bestsellerSwiper = new Swiper('.myBestsellerSwiper', {
    loop: true,
    loopedSlides: 12, 
    loopAdditionalSlides: 12, 
    
    centeredSlides: true,
    slidesPerView: 5, // Tırnaktan kurtarıp sayı yaptık
    grabCursor: true,
    speed: 800,
    
    loopPreventsSliding: false, 
    
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    
    navigation: {
        nextEl: '.swipe-button-next',
        prevEl: '.swipe-button-prev',
    },

    observer: true,
    observeParents: true,
    watchSlidesProgress: true,

    breakpoints: {
        // Mobil (Dikey - Telefonlar)
        320: {
            slidesPerView: 2, // Yan yana tam 2 slayt gösterir
            spaceBetween: 10,
            centeredSlides: false // Mobilde 2'li yapıda hizalamanın bozulmaması için gerekebilir
        },
        // Tablet / Büyük Ekran Mobil
        768: {
            slidesPerView: 2, 
            spaceBetween: 20,
            centeredSlides: false
        }
    },
    on: {
        init: function() {
            typeof Fancybox !== "undefined" && Fancybox.bind('[data-fancybox="gallery-video"]');
        },
        loopFix: function() {
            typeof Fancybox !== "undefined" && Fancybox.bind('[data-fancybox="gallery-video"]');
        }
    }
});
const comments = new Swiper('.comments-swiper', {
  loop:true,
  autoplay: {
   delay: 5000,
 },
  speed:600,
  // Okları aktif et
  navigation: {
    nextEl: '.swipe-button-next',
    prevEl: '.swipe-button-prev',
  },
  
  spaceBetween: 20,


    breakpoints: {
        575: {
            slidesPerView: 1, 
            coverflowEffect: { rotate: 0, stretch: 0, depth: 0 },
        },
        768: {
            slidesPerView: 2, 
            coverflowEffect: { rotate: 30, stretch: 0, depth: 100 },
        },
        991: {
            slidesPerView: 2, 
            coverflowEffect: { rotate: 30, stretch: 0, depth: 100 },
        },
        1440: {
            slidesPerView: '2', 
        }
    }
});

(function() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanes = document.querySelectorAll('.tab-pane');

    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');

            // Remove active class from all buttons and panes
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabPanes.forEach(pane => pane.classList.remove('active'));

            // Add active class to clicked button and corresponding pane
            this.classList.add('active');
            document.querySelector(`.tab-pane[data-tab="${tabName}"]`).classList.add('active');
        });
    });
})();

(function() {
    const productHero = document.getElementById('product-hero');
    if (!productHero) return;

    const mainImage = productHero.querySelector('.product-main-image img');
    const thumbs = productHero.querySelectorAll('.product-thumbnails .thumb');
    thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
            const imgEl = thumb.querySelector('img');
            if (!imgEl || thumb.classList.contains('active')) return;

            thumbs.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');

            mainImage.classList.remove('swap-animate');
            void mainImage.offsetWidth; // restart animation
            mainImage.src = imgEl.src;
            mainImage.alt = imgEl.alt;
            mainImage.classList.add('swap-animate');
        });
    });

    productHero.querySelectorAll('.variant-options').forEach(group => {
        group.addEventListener('click', (event) => {
            const target = event.target.closest('.color-swatch, .pill');
            if (!target) return;
            group.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
            target.classList.add('active');
        });
    });

    const qtyBox = productHero.querySelector('.qty-box');
    if (qtyBox) {
        const minusBtn = qtyBox.querySelector('button:first-child');
        const qtyInput = qtyBox.querySelector('input');
        const plusBtn = qtyBox.querySelector('button:last-child');
        const min = parseInt(qtyInput.min || '1', 10);

        const setQty = (val) => {
            const safeVal = Math.max(min, Number.isNaN(val) ? min : val);
            qtyInput.value = safeVal;
        };

        plusBtn?.addEventListener('click', () => setQty(parseInt(qtyInput.value, 10) + 1));
        minusBtn?.addEventListener('click', () => setQty(parseInt(qtyInput.value, 10) - 1));
        qtyInput?.addEventListener('input', () => setQty(parseInt(qtyInput.value, 10)));
    }

    const tabLabels = document.querySelectorAll('#product-details-tabs label');
    const tabPanels = document.querySelector('#product-details-tabs .tab-panels');
    tabLabels.forEach(label => {
        label.addEventListener('click', () => {
            if (!tabPanels) return;
            setTimeout(() => {
                tabPanels.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 40);
        });
    });

    const animatedBlocks = [
        ...document.querySelectorAll('#product-hero .col-lg-6'),
        ...document.querySelectorAll('#product-details-tabs .product-tabs'),
        ...document.querySelectorAll('#product-benefits .benefit-card'),
        ...document.querySelectorAll('#related-products .related-card')
    ];

    animatedBlocks.forEach(el => el.classList.add('animate-item'));

    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15 });

    animatedBlocks.forEach(el => revealObserver.observe(el));
})();


/* ai */


/* VEGA — Öne Çıkan Ürünler: renk swatch'ları + hızlı bakış / renk modalı */
(function () {
  'use strict';
  var NS = 'vegaProducts';
  if (window[NS]) { window[NS].init(document); return; }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function sized(url, w) { return url ? url.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Kart ---------- */
  function data(card) {
    if (!card.__vp) {
      try { card.__vp = JSON.parse($('script.vp-data', card).textContent); }
      catch (e) { card.__vp = { colors: [] }; }
    }
    return card.__vp;
  }

  function initSlider(el) {
    if (el.swiper || typeof window.Swiper === 'undefined') return;
    new window.Swiper(el, {
      speed: 450,
      nested: true,
      grabCursor: true,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true, dynamicBullets: true }
    });
  }

  function restoreSwap(card) {
    var img = card.__swapped;
    if (img && img.__orig) {
      img.src = img.__orig.src;
      if (img.__orig.srcset) img.setAttribute('srcset', img.__orig.srcset);
      card.__swapped = null;
    }
  }

  function showImage(card, c) {
    var slider = $('.product-card-slider', card);
    var sw = slider && slider.swiper;
    if (sw && c.index >= 0 && c.index < sw.slides.length) {
      restoreSwap(card);
      sw.slideTo(c.index);
      return;
    }
    if (!c.card) return;
    var img = slider ? $('.swiper-slide img', slider) : $('.product-image img', card);
    if (!img) return;
    if (!img.__orig) img.__orig = { src: img.src, srcset: img.getAttribute('srcset') };
    img.removeAttribute('srcset');
    img.src = c.card;
    card.__swapped = img;
    if (sw) sw.slideTo(0);
  }

  function applyColor(card, i, preview) {
    if (!card) return;
    var c = data(card).colors[i];
    if (!c) return;

    $$('[data-vp-swatch]', card).forEach(function (b) {
      var on = +b.getAttribute('data-vp-swatch') === i;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var price = $('[data-vp-price]', card), cmp = $('[data-vp-compare]', card),
        badge = $('[data-vp-badge]', card), nm = $('[data-vp-color-name]', card);
    if (price) price.textContent = c.price;
    if (cmp) { cmp.textContent = c.compare || ''; cmp.hidden = !c.compare; }
    if (badge) { badge.textContent = '-%' + c.pct; badge.hidden = !(c.pct > 0); }
    if (nm && c.name) nm.textContent = c.name;
    $$('[data-vp-link]', card).forEach(function (a) { a.href = c.url; });
    card.classList.toggle('is-oos', !c.available);
    showImage(card, c);

    if (!preview) { card.__vpIdx = i; card.__vpTouched = true; }
  }

  function restoreCard(card) {
    applyColor(card, card.__vpIdx || 0, true);
    if (!card.__vpTouched) {
      var nm = $('[data-vp-color-name]', card);
      if (nm && card.__vpOrigName) nm.textContent = card.__vpOrigName;
      restoreSwap(card);
      var s = $('.product-card-slider', card);
      if (s && s.swiper) s.swiper.slideTo(0);
    }
  }

  /* ---------- Modal ---------- */
  var st = {};

  function msg(text, type, html) {
    var el = st.m && $('[data-m-msg]', st.m);
    if (!el) return;
    el.className = 'vp-modal__msg' + (type ? ' is-' + type : '');
    if (html) el.innerHTML = text; else el.textContent = text || '';
  }

  function setGallery(imgs, k) {
    var m = st.m, main = $('[data-m-img]', m), th = $('[data-m-thumbs]', m);
    st.imgs = imgs || [];
    st.k = Math.max(0, Math.min(k || 0, st.imgs.length - 1));
    var src = st.imgs[st.k] || '';
    if (main.getAttribute('src') !== src) {
      main.classList.add('is-loading');
      main.onload = function () { main.classList.remove('is-loading'); };
      main.src = src;
    }
    main.alt = st.d.title || '';
    $$('[data-m-prev],[data-m-next]', m).forEach(function (b) { b.hidden = st.imgs.length < 2; });

    if (th.__imgs !== st.imgs) {
      th.innerHTML = st.imgs.map(function (u, j) {
        return '<button type="button" data-m-thumb="' + j + '" aria-label="Görsel ' + (j + 1) + '"><img src="' + esc(sized(u, 200)) + '" alt="" loading="lazy"></button>';
      }).join('');
      th.__imgs = st.imgs;
    }
    th.hidden = st.imgs.length < 2;
    $$('[data-m-thumb]', th).forEach(function (b) {
      var on = +b.getAttribute('data-m-thumb') === st.k;
      b.classList.toggle('is-active', on);
      if (on && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function renderSwatches() {
    var m = st.m, cs = st.d.colors, wrap = $('[data-m-swatches]', m);
    $('[data-m-color-wrap]', m).hidden = !(cs.length > 1 || (cs[0] && cs[0].name));
    wrap.innerHTML = cs.map(function (c, i) {
      var t = c.images[0] ? sized(c.images[0], 180) : (c.sw || '');
      return '<button type="button" class="vp-mswatch' + (c.available ? '' : ' is-oos') + '" data-m-swatch="' + i + '" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + (c.available ? '' : ' (Tükendi)') + '" aria-pressed="false">' +
        (t ? '<img src="' + esc(t) + '" alt="" loading="lazy">' : '') +
        '<span class="vp-mswatch__dot" style="--sw:' + esc(c.hex || '#e5e7eb') + ';' + (c.sw && !c.hex ? '--sw-img:url(\'' + esc(c.sw) + '\')' : '') + '"></span></button>';
    }).join('');
  }

  function selectModal(i) {
    var m = st.m, c = st.d.colors[i];
    if (!c) return;
    st.i = i;
    $$('[data-m-swatch]', m).forEach(function (b) {
      var on = +b.getAttribute('data-m-swatch') === i;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('[data-m-color]', m).textContent = c.name || '';
    $('[data-m-price]', m).textContent = c.price;
    var cmp = $('[data-m-compare]', m); cmp.textContent = c.compare || ''; cmp.hidden = !c.compare;
    var pct = $('[data-m-pct]', m); pct.textContent = c.pct > 0 ? '%' + c.pct + ' indirim' : ''; pct.hidden = !(c.pct > 0);
    $('[data-m-link]', m).href = c.url;
    var atc = $('[data-m-atc]', m);
    atc.disabled = !c.available;
    $('[data-m-atc-label]', m).textContent = c.available ? 'Sepete Ekle' : 'Tükendi';
    msg('');
    setGallery(c.images, 0);
    applyColor(st.card, i);
  }

  function openModal(card, i) {
    var sec = card.closest('[data-vp-section]');
    var m = sec && document.getElementById('vp-modal-' + sec.getAttribute('data-vp-section'));
    var d = data(card);
    if (!m || !d.colors.length) {
      var a = $('[data-vp-link]', card);
      if (a) window.location.href = a.href;
      return;
    }
    st = { m: m, card: card, d: d, last: document.activeElement };
    $('[data-m-cat]', m).textContent = d.type || '';
    $('[data-m-title]', m).textContent = d.title || '';
    $('[data-m-qty]', m).value = 1;
    $('[data-m-thumbs]', m).__imgs = null;
    renderSwatches();
    selectModal(typeof i === 'number' ? i : (card.__vpIdx || 0));

    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vp-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-open'); }); });
    setTimeout(function () { var x = $('.vp-modal__close', m); if (x) x.focus({ preventScroll: true }); }, 60);
  }

  function closeModal() {
    var m = st.m;
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vp-lock');
    setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 280);
    var last = st.last;
    st = {};
    if (last && last.focus) last.focus({ preventScroll: true });
  }

  function updateCartUI(cart) {
    var detail = {
      resource: cart,
      sourceId: 'vega-products',
      data: { source: 'vega-products', itemCount: cart.item_count, productId: String(st.d && st.d.id || ''), didError: false }
    };
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    $$('[data-cart-count], .cart-count, .cart-count-bubble span, .cart-bubble__text-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function addToCart() {
    var m = st.m, c = st.d.colors[st.i], btn = $('[data-m-atc]', m);
    if (!c || !c.available || btn.classList.contains('is-loading')) return;
    var qty = Math.max(1, parseInt($('[data-m-qty]', m).value, 10) || 1);
    btn.classList.add('is-loading');
    btn.disabled = true;
    msg('');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: c.id, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        msg('Sepete eklendi ✓ <a href="' + ROOT + 'cart">Sepete git</a>', 'ok', true);
        updateCartUI(cart);
      })
      .catch(function (e) {
        msg((e && (e.description || e.message)) || 'Bir sorun oluştu, lütfen tekrar deneyin.', 'err');
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.disabled = !c.available;
      });
  }

  /* ---------- Olaylar ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var sw = t.closest('[data-vp-swatch]');
    if (sw) { e.preventDefault(); applyColor(sw.closest('[data-vp-card]'), +sw.getAttribute('data-vp-swatch')); return; }

    var op = t.closest('[data-vp-open]');
    if (op) { e.preventDefault(); openModal(op.closest('[data-vp-card]')); return; }

    if (t.closest('[data-vp-card] .swiper-pagination')) { e.preventDefault(); return; }

    if (!st.m || !st.m.contains(t)) return;
    if (t.closest('[data-vp-close]')) { closeModal(); return; }

    var ms = t.closest('[data-m-swatch]');
    if (ms) { selectModal(+ms.getAttribute('data-m-swatch')); return; }

    var th = t.closest('[data-m-thumb]');
    if (th) { setGallery(st.imgs, +th.getAttribute('data-m-thumb')); return; }

    if (t.closest('[data-m-prev]')) { setGallery(st.imgs, (st.k - 1 + st.imgs.length) % st.imgs.length); return; }
    if (t.closest('[data-m-next]')) { setGallery(st.imgs, (st.k + 1) % st.imgs.length); return; }

    var q = $('[data-m-qty]', st.m);
    if (t.closest('[data-m-minus]')) { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); return; }
    if (t.closest('[data-m-plus]')) { q.value = (parseInt(q.value, 10) || 1) + 1; return; }

    if (t.closest('[data-m-atc]')) { addToCart(); }
  });

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  document.addEventListener('mouseover', function (e) {
    if (!canHover || !e.target.closest) return;
    var sw = e.target.closest('[data-vp-swatch]');
    if (sw) applyColor(sw.closest('[data-vp-card]'), +sw.getAttribute('data-vp-swatch'), true);
  });
  document.addEventListener('mouseout', function (e) {
    if (!canHover || !e.target.closest) return;
    var box = e.target.closest('.vp-swatches');
    if (!box || box.contains(e.relatedTarget)) return;
    restoreCard(box.closest('[data-vp-card]'));
  });

  document.addEventListener('keydown', function (e) {
    if (!st.m) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'ArrowLeft' && st.imgs && st.imgs.length > 1 && !/INPUT/.test(document.activeElement.tagName)) setGallery(st.imgs, (st.k - 1 + st.imgs.length) % st.imgs.length);
    if (e.key === 'ArrowRight' && st.imgs && st.imgs.length > 1 && !/INPUT/.test(document.activeElement.tagName)) setGallery(st.imgs, (st.k + 1) % st.imgs.length);
    if (e.key === 'Tab') {
      var f = $$('button:not([disabled]):not([hidden]), a[href], input', st.m).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Init ---------- */
  function initSliders(root) { $$('.product-card-slider', root).forEach(initSlider); }

  function init(root) {
    root = root || document;
    var secs = root.matches && root.matches('[data-vp-section]') ? [root] : $$('[data-vp-section]', root);
    secs.forEach(function (sec) {
      var m = $('[data-vp-modal]', sec);
      if (!m) return;
      $$('#' + m.id).forEach(function (old) { if (old !== m) old.remove(); });
      document.body.appendChild(m);
    });

    $$('[data-vp-card]', root).forEach(function (card) {
      if (card.__vpInit) return;
      card.__vpInit = true;
      var a = +card.getAttribute('data-vp-active') || 0;
      card.__vpIdx = a;
      var nm = $('[data-vp-color-name]', card);
      card.__vpOrigName = nm ? nm.textContent : '';
      $$('[data-vp-swatch]', card).forEach(function (b) {
        var on = +b.getAttribute('data-vp-swatch') === a;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    // Tema kendi swiper init'ini yapıyorsa önce o çalışsın; biz yalnızca kurulmamışları kuruyoruz.
    if (document.readyState === 'complete') initSliders(root);
  }

  window.addEventListener('load', function () { initSliders(document); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSliders(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (st.m && id && st.m.id === 'vp-modal-' + id) closeModal();
    $$('[data-vp-modal]').forEach(function (m) { if (id && m.id === 'vp-modal-' + id) m.remove(); });
  });

  window[NS] = { init: init, open: openModal };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();